module.exports = __webpack_public_path__ + "museosans_500-webfont.6c16fc4b7c3f0ad6e4d3.woff2";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/museosans_500-webfont.woff2
// module id = ../../../../../src/assets/fonts/museosans_500-webfont.woff2
// module chunks = styles